export default "__VITE_ASSET__DCWQDF$l__"